/* eslint-disable no-useless-catch */
/* eslint-disable unused-imports/no-unused-vars */
import { API } from "../api";
import { CLIENT_PICKUP_REQUEST } from "../constants/url.constant";

export const ADD_CLIENT_PICKUP_REQUEST = "ADD_CLIENT_PICKUP_REQUEST";
export const GET_ALL_CLIENT_PICKUP_REQUEST = "GET_ALL_CLIENT_PICKUP_REQUEST";
export const GET_CLIENT_PICKUP_REQUEST = "GET_CLIENT_PICKUP_REQUEST";
export const SET_CLIENT_PICKUP_LIST = "SET_CLIENT_PICKUP_LIST";
export const SET_SEARCH_RESULT = "SET_SEARCH_RESULT";

export const addClientPickupRequest = (data) => {
  return async (dispatch) => {
    try {
      const res = await API.post(CLIENT_PICKUP_REQUEST, data);
      dispatch({
        type: ADD_CLIENT_PICKUP_REQUEST,
        payload: data
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const getPickupRequests = (params = {}) => {
  return async (dispatch) => {
    try {
      const res = await API.get(CLIENT_PICKUP_REQUEST, {
        params: params
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const getPickupRequestById = (id) => {
  return async (dispatch) => {
    try {
      const res = await API.get(`${CLIENT_PICKUP_REQUEST}/${id}`);
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const updatePickupRequestById = (id, data) => {
  return async (dispatch) => {
    try {
      const res = await API.put(`${CLIENT_PICKUP_REQUEST}/${id}`, data);
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const exportPickupRequest = (data) => {
  return async (dispatch) => {
    try {
      await API.post(`${CLIENT_PICKUP_REQUEST}/export`, data);
    } catch (error) {
      throw error;
    }
  };
};

export const filterPickupRequest = (data) => {
  return async (dispatch) => {
    try {
      const payload = await API.post(`${CLIENT_PICKUP_REQUEST}/filter`, data);
      return payload;
    } catch (error) {
      throw error;
    }
  };
};

const initialState = {
  columns: [],
  data: [],
  totalRows: 0,
  order: {}
};

export default function reducer(state = initialState, { type, payload }) {
  switch (type) {
    case GET_ALL_CLIENT_PICKUP_REQUEST:
      return {
        ...state,
        columns: payload.columns,
        data: payload.rows,
        totalRows: payload.count
      };
    default:
      return state;
  }
}
